import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  setAuthToken,
  setCurrentPage,
  setActiveCandidateId,
} from '../../actions/actions'
import CandidateListing from './CandidateListing'
import ResumeListing from './ResumeListing'
import RenameResumeModal from '../modals/RenameResumeModal'
import Loader from '../components/Loader'
import '../../styles/_notifications.scss'

// require('bootstrap')
import '../../styles/_bootstrap.scss'
import '../../styles/_modals.scss'

const Home = () => {
  const page = useSelector((state) => state.currentPage)
  const renameResumeModalOpen = useSelector(
    (state) => state.renameResumeModal.isOpen
  )
  const activeCandidateId = useSelector((state) => state.activeCandidateId)
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()
  const token = searchParams.get('sessionToken')
  const candidateId = searchParams.get('candidateId')

  useEffect(() => {
    if (token) {
      dispatch(setAuthToken(token))
    }
    if (candidateId) {
      dispatch(setActiveCandidateId(candidateId))
      dispatch(setCurrentPage('resume_listing'))
    } else {
      dispatch(setCurrentPage('candidate_listing'))
    }
  }, [searchParams])

  if (page == null) {
    return <Loader />
  }

  return page === 'candidate_listing' ? (
    <>
      <CandidateListing />
      {renameResumeModalOpen && <RenameResumeModal />}
    </>
  ) : (
    <ResumeListing />
  )
}

export default Home
